import { createSelector } from '@ngrx/store';


export const selectAuthState = state => state.login;


export const selectIsloggedIn=createSelector(
    selectAuthState,
    auth =>auth.loggedIn
);